const computeType = {
  list () {
    return new Promise((resolve, reject) => {
      let data = [
        {id: 1, name: '纬密'},
        {id: 2, name: '滚筒'}
      ]
      setTimeout(resolve, 10, data)
    })
  }
}

export default computeType



// WEBPACK FOOTER //
// ./src/api/computeType.js